import { components, paths } from "@api/api";
import useAxios from "@hooks/useFetch";
import { useMemo } from "react";
import { KeywordBase, KeywordTableColumn, useGetKeywordBaseData } from "@api/useGetKeywordBaseData";
import { RespondentType } from "@models/RespondentType";
import { useGetRespondentType } from "@core/CommonDataContext";


const REQUEST_PATH: keyof paths = '/api/Search/GetPeopleIndexes';
export type HomePeopleIndexRequestPayload = components["schemas"]["FlavorTracker.Entities.DTO.SearchPage.SearchPageMetricIndexesRequest"];
export type HomePeopleIndexRequestPayloadMainModel = NonNullable<HomePeopleIndexRequestPayload["mainModel"]>;
export type HomePeopleIndexRequestPayloadIndexModel = NonNullable<HomePeopleIndexRequestPayload["indexToModel"]>;
type ResponseData = components["schemas"]["FlavorTracker.Entities.DTO.SearchPage.SearchPagePeopleIndexesResponse"][];

export type HomePeopleIndexDataItem = KeywordBase & {
    columns: Map<RespondentType, KeywordTableColumn<RespondentType>>;
}

export function useHomePeopleIndexData(payload: HomePeopleIndexRequestPayload) {
    const getKeywordBaseData = useGetKeywordBaseData();
    const getRespondentType = useGetRespondentType();

    const response = useAxios<ResponseData, HomePeopleIndexRequestPayload>({
        url: REQUEST_PATH,
        method: 'post',
        payload,
    });

    const data = useMemo(
        (): HomePeopleIndexDataItem[] => {
            return (response.data ?? []).map(item => {
                const itemBase = getKeywordBaseData(item.id ?? 0);
                const columns = new Map<RespondentType, KeywordTableColumn<RespondentType>>();

                (item.dataByRespondentType ?? []).forEach(i => {
                    const colData = getRespondentType(i.id ?? RespondentType.NoData);

                    const value = i.index ?? null;

                    columns.set(i.id ?? RespondentType.NoData, {
                        id: colData?.id ?? RespondentType.NoData,
                        name: colData?.name ?? '',
                        value,
                        tableValue: value !== null ? `${value}` : '-',
                        copyTableValue: value !== null ? `${value}` : '-',
                        sortValue: i.index ?? null,
                        norm: null,
                    });
                })

                return {
                    ...itemBase,
                    columns,
                };
            });
        },
        [response.data, getKeywordBaseData, getRespondentType]
    );

    return {
        ...response,
        data,
    };
}